import { ShieldCheck } from 'lucide-react'
import { de } from '../../i18n'

/**
 * The signed-out frame for the admin application. Deliberately quieter than
 * apps/web's split-screen AuthLayout: that one sells the product to a
 * prospective customer, and there is no one here to sell to — whoever opens
 * this address already knows what BusinessBuddy is and is here to operate
 * it. One centered panel on the same sheet/surface tokens as the customer
 * app, so the two read as the same product without either borrowing the
 * other's content.
 */
export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-sheet px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          <span
            aria-hidden
            className="flex size-10 items-center justify-center rounded-[var(--radius-panel)] bg-accent-solid text-accent-solid-ink"
          >
            <ShieldCheck className="size-5" />
          </span>
          <div>
            <p className="text-lg font-semibold tracking-tight text-ink">{de.app.name}</p>
            <p className="text-base text-ink-muted">{de.app.suiteName}</p>
          </div>
        </div>

        <div className="rounded-[var(--radius-panel)] border border-rule bg-surface p-6 shadow-popover">
          <h1 className="text-md font-semibold text-ink">{de.auth.login.title}</h1>
          <p className="mt-1 text-base text-ink-muted">{de.auth.login.subtitle}</p>
          <div className="mt-6">{children}</div>
        </div>
      </div>
    </div>
  )
}
